module.exports = __webpack_public_path__ + "../resources/images/illustration_flagged-870b554c486798ff965e47634ec8cf86.svg";